/**
 * This file contains some syntactic-sugar wrappers for making HeadlingLevelBoundary
 * easier to work with.
 */ import _extends from "@swc/helpers/src/_extends.mjs";
import React, { forwardRef } from 'react';
import HeadingLevelBoundary from './HeadingLevelBoundary';
/**
 * Render a `section` tag and handle updating the heading level context
 */ const Section = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ React.createElement(HeadingLevelBoundary, _extends({
        tag: "section"
    }, props, {
        ref: ref
    })));
Section.displayName = 'Section';
/**
 * Render a `main` tag and handle updating the heading level context
 */ const Main = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ React.createElement(HeadingLevelBoundary, _extends({
        tag: "main"
    }, props, {
        ref: ref
    })));
Main.displayName = 'Main';
/**
 * Render a `nav` tag and handle updating the heading level context
 */ const Nav = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ React.createElement(HeadingLevelBoundary, _extends({
        tag: "nav"
    }, props, {
        ref: ref
    })));
Nav.displayName = 'Nav';
export { Section, Main, Nav };
